import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import React from 'react';

const Banner = ({
  open,
  message,
  severity = 'info',
  onClose,
  autoHideDuration = 4000,
}) => (
  <Snackbar
    open={open}
    autoHideDuration={autoHideDuration}
    onClose={onClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
  >
    <MuiAlert
      elevation={6}
      variant="filled"
      onClose={onClose}
      severity={severity}
      sx={{ width: '100%' }}
    >
      {message}
    </MuiAlert>
  </Snackbar>
);

export default Banner;
